import React, { Component } from '../../lib/react';
import { Layout, Tabs } from "antd";
import { hashHistory } from 'react-router';

import Login from "../../components/Login/Login";

import './authPage.less'

const { Header } = Layout;
const { TabPane } = Tabs;

export default class AuthPage extends Component {
  state = {
    activeType: 'auth',
    activeSubType: '',
  };

  setStateHandler(key) {
    this.setState({ activeType: key});
  }

  setStateSubHandler(key) {
    this.setState({ activeSubType: key});
  }

  getRandomInt(max) {
    return Math.floor(Math.random() * Math.floor(max));
  }

  render () {
    const { user } = this.props;
    const { activeType, activeSubType } = this.state;

    if (user && user.uid) {
      hashHistory.push(`/Channels`);
    }

    return (
      <React.Fragment>
        <Header className="header">
          <div className="header-inner">
            <h1>Registration</h1>
          </div>
        </Header>
        <Tabs
          onChange={this.setStateHandler}
          className="login-panel"
          activeKey={activeType}
        >
          <TabPane tab="Sign In" key="auth">
            <div className="tab-content">
              <div className="container">
                <Login
                  type={"auth"}
                  activeType={activeType}
                  activeSubType={activeSubType}
                  redirect={true}
                  setStateHandler={this.setStateHandler}
                  setStateSubHandler={this.setStateSubHandler}
                />
              </div>
            </div>
          </TabPane>
          <TabPane tab="" key="registration">
            <div className="tab-content">
              <div className="container">
                <Login
                  type={"registration"}
                  activeType={activeType}
                  activeSubType={activeSubType}
                  redirect={true}
                  setStateHandler={this.setStateHandler}
                  captchaId={`captcha-${this.getRandomInt(100)}`}
                />
              </div>
            </div>
          </TabPane>
        </Tabs>
      </React.Fragment>
    )
  }
}



// WEBPACK FOOTER //
// ./src/pages/AuthPage/index.js